import React, { useState, useEffect } from "react";
import { getAllProductReview } from "../utils/getAllProductReview";
import { publishProductReview } from "../utils/publishProductReview";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatDateDDMMMYYYY } from "../utils/dateHelpers";

const ProductReview = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all reviews on mount.
  useEffect(() => {
    getAllProductReview()
      .then((data) => {
        // Sort reviews by createdAt date descending (latest on top)
        const sortedReviews = data.sort(
          (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
        );
        setReviews(sortedReviews);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Error fetching product reviews");
        setLoading(false);
      });
  }, []);

  // Handler to toggle publish status and update the review state.
  const handleTogglePublish = async (review) => {
    try {
      const newStatus = await publishProductReview(
        review.reviewId,
        review.isPublished
      );
      setReviews((prevReviews) =>
        prevReviews.map((r) =>
          r.reviewId === review.reviewId ? { ...r, isPublished: newStatus } : r
        )
      );
    } catch (error) {
      toast.error("Failed to update publish status");
    }
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-[60vh]">
        <div className="spin-loader"></div>
      </div>
    );
  if (error)
    return (
      <div className="flex justify-center items-center h-[60vh] text-red-500">
        {error}
      </div>
    );

  return (
    <div className="overflow-y-auto md:max-h-[calc(100vh-185px)] max-h-[calc(100vh-265px)] scroll-bar">
      <table className="min-w-full text-sm whitespace-nowrap">
        <thead className="bg-[#EFF4FF] text-[#929EB6] border-b border-[#D1DFFC] sticky top-0 z-[2]">
          <tr>
            <th className="p-4 text-left font-medium">S.No</th>
            <th className="p-4 text-left font-medium">User Name</th>
            <th className="p-4 text-left font-medium">Comments</th>
            <th className="p-4 text-left font-medium">Created Date</th>
            <th className="p-4 text-left font-medium">Published</th>
            <th className="p-4 text-left font-medium">Action</th>
          </tr>
        </thead>
        <tbody>
          {reviews.map((review, index) => (
            <tr
              key={review.reviewId}
              className={`${
                index % 2 === 0 ? "bg-[#F4F7FF]" : "bg-[#EBF1FF]"
              } border-b border-[#DCE2EC]`}
            >
              <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                {index + 1}
              </td>
              <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                {review.userName}
              </td>
              <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                <p className="max-w-[500px] whitespace-normal">{review.comments}</p>
              </td>
              <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                {formatDateDDMMMYYYY(review.createdDate)}
              </td>
              <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                {review.isPublished === 1 ? "Published" : "Unpublished"}
              </td>
              <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                <button
                  onClick={() => handleTogglePublish(review)}
                  className="px-3 py-1 rounded bg-blue-500 text-white"
                >
                  {review.isPublished === 1 ? "Unpublish" : "Publish"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ToastContainer />
    </div>
  );
};

export default ProductReview;
